import React from "react";
import LegalPage from "@/components/LegalPage";

export default function Terms() {
  return (
    <LegalPage
      title="Terms of Service"
      eyebrow="Booking conditions"
      intro="These Terms of Service govern your use of the Tour Trips India Holidays website and the booking of any tour, transfer or service. By placing a booking, you (the 'Customer') accept these terms in full."
      seoDesc="Terms of Service governing bookings on Tour Trips India Holidays — your contract with us as your inbound tour operator in India."
      sections={[
        {
          heading: "1. The contract",
          paragraphs: [
            "A booking is confirmed only after we receive your signed booking voucher and the agreed deposit (typically 25% of tour value; final balance schedule shared on the payment link).",
            "Once we send your written confirmation, a binding contract exists between you and Tour Trips India Holidays (proprietorship registered in Agra, Uttar Pradesh, India) governed by Indian law and subject to the exclusive jurisdiction of Agra courts.",
          ],
        },
        {
          heading: "2. Pricing & currency",
          paragraphs: [
            "Prices on the website are displayed in USD (default) and Indian Rupees. The USD price is the binding price for international guests. Currency conversion losses incurred by your bank are not our responsibility.",
            "Prices include the services explicitly listed in 'Inclusions' on each tour page. They exclude items listed in 'Exclusions', international flights, India visa fees, travel insurance, tips, and any monument photography fees unless otherwise mentioned.",
            "We reserve the right to revise pricing in case of significant changes in monument entry fees, government taxes, or fuel costs notified before final payment.",
          ],
        },
        {
          heading: "3. Travel documents & visa",
          paragraphs: [
            "It is the Customer's sole responsibility to hold a valid passport (≥6 months residual validity), a valid Indian e-Visa or tourist visa, and any onward-country visas (Nepal, UAE, Thailand) where applicable.",
            "We will provide a confirmation letter and itinerary on request to support your visa application. We are not liable for any loss arising from visa refusal or denied entry.",
          ],
        },
        {
          heading: "4. Travel insurance",
          paragraphs: [
            "Comprehensive travel insurance covering medical evacuation, trip cancellation, baggage loss and adventure activities is mandatory for every traveler. Proof of insurance may be requested at any time during the tour.",
          ],
        },
        {
          heading: "5. Tour content & changes",
          paragraphs: [
            "Itineraries are crafted to be both comfortable and authentic. Minor changes (hotel substitutions of equivalent or higher category, sequence reversal of days, alternate sites in case of monument closure) may be made without prior notice.",
            "Significant changes (route change of >150 km or addition/removal of an entire destination) will be communicated to you with the option to accept or cancel without penalty.",
          ],
        },
        {
          heading: "6. Force majeure",
          paragraphs: [
            "We are not liable for delays, changes, or cancellations caused by events beyond our reasonable control — including but not limited to natural disasters, pandemics, war, terrorism, civil unrest, government restrictions, road closures, or airline strikes.",
            "In such cases we will work with you to either rebook for a later date (no extra charge) or refund any unutilised, non-recoverable supplier deposits.",
          ],
        },
        {
          heading: "7. Behaviour & responsibility",
          paragraphs: [
            "The Customer agrees to behave respectfully toward our staff, guides, drivers, hotel partners, and fellow guests, and to follow local cultural norms (modest dress at religious sites, no photography where prohibited).",
            "We reserve the right to terminate the tour without refund if a guest's conduct creates safety risk, harms our staff, or damages property.",
          ],
        },
        {
          heading: "8. Limitation of liability",
          paragraphs: [
            "Our maximum liability for any single booking is limited to the total amount paid by the Customer to Tour Trips India Holidays for that booking. We are not liable for any indirect, incidental, or consequential damages.",
          ],
        },
        {
          heading: "9. Disputes",
          paragraphs: [
            "All disputes are subject to good-faith negotiation first, then mediation, and only failing that the exclusive jurisdiction of competent courts in Agra, Uttar Pradesh, India.",
          ],
        },
      ]}
    />
  );
}
